export type tabs = "list" | "create";

export enum TabType {
  LIST = "list",
  CREATE = "create",
}

export enum ViewType {
  DASHBOARD = "Dashboard",
  TEMPLATE = "Template Gallery",
  CLINICAL_PRACTICE = "Clinic",
  AI_RECEPTIONIST = "Front-Desk",
  COMPLIANCE = "Compliance",
}

export type CustomNote = {
  id: number;
  pk: number;
  from_template?: number;
  name: string;
  document: string;
  prompt?: string;
  finished_generating: boolean;
  is_group_accessible?: boolean;
  is_owner?: boolean;
  settings: {
    is_addon: boolean;
    is_cpt_codes: boolean;
    visit_type?: number;
    forked_from_custom_note_id?: number;
    procedural_coding_instructions?: string;
  };
  status: 1 | 0 | 2;
};
